export default __webpack_public_path__ + "static/media/circuitos.d2d06cce.svg";